import API from '@/api/index';
import validate from '@/utils/validate';

const tracking = {
  state: {
    searchText: '',
    searchResults: [],
    company: null,
    companies: [],
    historyMessages: [],
    availableMessages: []
  },

  mutations: {
    SET_SEARCH_TEXT: (state, text) => { state.searchText = text },
    SET_SEARCH_RESULTS: (state, data) => { state.searchResults = data },
    SET_COMPANY: (state, data) => { state.company = data },
    SET_COMPANIES: (state, data) => {
      if (!state.companies.includes(data)) state.companies.push(data);
    },
    REMOVE_COMPANIES: (state, data) => {
      if (state.companies.includes(data)) state.companies = state.companies.filter(a => a.Id !== data.Id);
    },
    SET_HISTORY_MESSAGES: (state, data) => {
      state.historyMessages = data;
    },
    SET_AVAILABLE_MESSAGES: (state, data) => {
      state.availableMessages = data;
    }
  },

  actions: {

    SeachCompanyRequest ({ rootState, commit, state }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .SeachCompanyRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) {
              // console.log('TCL: SeachCompanyRequest -> result.Data', result.Data);

              let searchTextRemovedVietnamese = validate.transferVietnamese(state.searchText).toLowerCase();

              result.Data.forEach(item => {
                Object.assign(item, { MatchUsers: [] });
                item.Users.forEach(user => {
                  let usernameRemoveVietnamese = validate.transferVietnamese(`${user.Username}${user.Email}`).toLowerCase();
                  if (usernameRemoveVietnamese.includes(searchTextRemovedVietnamese)) {
                    item.MatchUsers.push(user);
                  }
                });
              });

              result.Data.forEach(item => {
                Object.assign(item, { MatchVehicles: [] });
                item.Vehicles.forEach(vehicle => {
                  let plateRemoveVietnamese = validate.transferVietnamese((vehicle.Plate || '').toLowerCase());
                  if (plateRemoveVietnamese.includes(searchTextRemovedVietnamese)) {
                    item.MatchVehicles.push(vehicle);
                  }
                });
              });

              let merge = [];
              if (state.companies.length > 0) {
                merge = [...state.companies];
                let selectedIds = state.companies.map(a => a.Id);
                result.Data.map(a => {
                  if (!selectedIds.includes(a.Id)) { merge.push(a) }
                  return 0;
                });

              } else {
                merge = result.Data;
              }

              commit('SET_SEARCH_RESULTS', merge);
              resolve(merge);
            }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    CompanyRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .CompanyRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetDevicesSettingRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetDevicesSettingRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetUserLoginKeyRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetUserLoginKeyRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetUsersByVehicleRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetUsersByVehicleRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetVehiclesSettingRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetVehiclesSettingRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    VehiclesRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .VehiclesRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    TimeRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .TimeRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetCompanyBillingStatusesRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetCompanyBillingStatusesRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    VehicleStatusRequest ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .VehicleStatusRequest(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    VehicleDailyReport ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .VehicleDailyReport(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result) }
          })
          .catch(error => { reject(error) });
      });
    },

    GetDailyTripReport ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetDailyTripReport(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    WriteReportToGoogleSheet ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .WriteReportToGoogleSheet(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    SendSMS ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .SendSMS(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },
    NewAvailableMessage ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .NewAvailableMessage(data)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },
    GetHistoryMessages ({ rootState }, Token) {
      Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetHistoryMessages(Token)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },
    GetAvailableMessage ({ rootState }, Token) {
      Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .GetAvailableMessage(Token)
          .then(response => {
            let result = response.data;
            if (result.Data) { resolve(result.Data) }
            else { reject(result.Code) }
          })
          .catch(error => { reject(error) });
      });
    },
    UpdateAvailableMessage ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .UpdateAvailableMessage(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DeleteAvailableMessage ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .DeleteAvailableMessage(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    SearchCompanyByPhone ({ rootState }, data) {
      data.Token = rootState.user.token;
      return new Promise((resolve, reject) => {
        API.tracking
          .SearchCompanyByPhone(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UpdateCompany ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.tracking
          .UpdateCompany(data)
          .then(response => {
            if (response.data.Data) {
              resolve(response.data.Data);
            } else {
              reject(response.data.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default tracking;


// WEBPACK FOOTER //
// ./src/store/modules/tracking.js